(function () {
  function getConfig() {
    return window.craftCellarsLocationConfig || null;
  }

  function isLocationModalEnabled() {
    return getConfig()?.enabled === true;
  }

  function getSelection() {
    return window.CraftCellarsLocation?.getSelection?.() || null;
  }

  function openLocationModal() {
    if (!isLocationModalEnabled()) return;

    const modal = document.querySelector('location-selector-modal');
    if (modal?.show) {
      modal.show();
      return;
    }
    console.warn('Location modal not found');
  }

  function syncHeaderLocations() {
    if (!isLocationModalEnabled()) return;

    const picker = document.querySelector('[data-header-location-picker]');
    if (!picker) return;

    const config = getConfig();
    const selection = getSelection();
    const selectedKey = selection?.key || config?.defaultLocationKey;

    picker.querySelectorAll('.header-locations--interactive [data-location-key]').forEach((item) => {
      const key = item.dataset.locationKey;
      const loc = config?.locations?.[key];
      const addressEl = item.querySelector('[data-location-address]');

      if (loc?.address && addressEl) {
        addressEl.textContent = loc.address;
      }

      const isSelected =
        Boolean(selectedKey && key === selectedKey) && selection?.type !== 'custom';
      item.classList.toggle('is-selected', isSelected);
      item.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });
  }

  function bindHeaderTriggers() {
    if (!isLocationModalEnabled()) return;

    document.querySelectorAll('[data-location-picker-trigger]').forEach((trigger) => {
      if (trigger.dataset.locationPickerBound) return;
      trigger.dataset.locationPickerBound = 'true';
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        openLocationModal();
      });
    });
  }

  function init() {
    bindHeaderTriggers();
    syncHeaderLocations();
  }

  document.addEventListener('craft-cellars:location-selected', () => {
    syncHeaderLocations();
  });

  // Theme editor can toggle enable_modal and re-render only the modal section.
  // Re-run bind/sync so Change Store works after enabling without a full reload.
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);

  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();

  window.CraftCellarsLocation = window.CraftCellarsLocation || {};
  window.CraftCellarsLocation.openModal = openLocationModal;
  window.CraftCellarsLocation.syncHeader = syncHeaderLocations;
})();
